document.addEventListener('DOMContentLoaded', function() {
  // Initialize the Swiper slider – only when the section gets close to the screen,
  // so its photos are not downloaded and it does not animate while far below.
  var el = document.querySelector('.reviewSwiper');
  if (el && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); initReviewsSlider(); }
    }, { rootMargin: '600px 0px' });
    io.observe(el);
  } else {
    initReviewsSlider();
  }
  
  // Set up button padding and click event
  setupClaimButton();
});

/**
 * Initializes the reviews slider with Swiper
 */
function initReviewsSlider() {
  var swiper = new Swiper(".reviewSwiper", {
    slidesPerView: "auto",
    spaceBetween: 15,
    centeredSlides: false,
    loop: true,
    speed: parseInt(document.querySelector('.reviewSwiper').dataset.speed || 5000),
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    allowTouchMove: true,
    grabCursor: true,
    freeMode: {
      enabled: false
    },
    preloadImages: false
  });
  // pause the endless scroll while the section is off screen
  var el = document.querySelector('.reviewSwiper');
  if (el && swiper.autoplay && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) swiper.autoplay.start(); else swiper.autoplay.stop(); });
    }).observe(el);
  }
}

/**
 * Sets up the claim button padding and event handling
 */
function setupClaimButton() {
  var claimButton = document.querySelector('.claim-button');
  if (claimButton) {
    // Button padding is now handled via inline styles
  }
}

/**
 * Scrolls to the top of the page
 * @param {Event} event - The click event
 */
function scrollToTop(event) {
  // Always prevent default since we're always using '#' as href
  event.preventDefault();

  // Smooth scroll to top
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
} 